import { AppState } from '../../../types/store';
import { DeliveriesStore } from '../../../types/store/deliveries';

export const deliveriesSelector = (state: AppState): DeliveriesStore => state.deliveries;
